import UploadImg from '@/components/UploadImg/UploadImg';
import BootstrapModal from '@/components/Modal/BootstrapModal/BootstrapModal';
import { mapGetters, mapActions } from 'vuex';
import { realNameApi } from '@/api/user/realName';
import { seniorCertificationApi } from '@/api/user/seniorCertification';
import { selectOption } from '@/common/constants/selectOption';
import { getErrorLabelMixin } from '@/common/mixin/getErrorLabel.js';
import errMsg from './errorMsg.js';

import tool from '@/common/js/tool';
import { getterTypes } from '@/store/getter-types';

export default {
  name: 'RealName',
  mixins: [getErrorLabelMixin],
  data() {
    return {
      // 判断上传插件是否需要初始化，因为用户提交过资料后会立即跳转至详情页，因此这里需要做个判断
      uploaderCanInit: false,
      // 表单数据
      form: {
        year: '',
        month: '',
        day: '',
        lastname: '',
        name: '',
        givenName: '', // 姓名拼音
        realName: '', // 真实姓名
        birthday: '', // 出生日期 1989-01-23
        countryCode: '', // 国籍 86
        countryName: '', // 国籍名称
        identifyImgUrl1: '', // 证件正面照
        identifyImgUrl2: '', // 证件反面照
        identifyImgUrl3: '', // 手持证件照
        identityNo: '', // 证件号码
        identityType: '', // 证件类型
        identityName: '', // 证件类型对应的文字
        nickName: '', // 昵称
        sex: '', // 性别
        // 原高级认证数据
        apartmentNumber: '', // 公寓号
        authImgUrl1: '', // 居住证明图片地址
        authImgUrl2: '', // AML表单图片地址
        buildingNumber: '', // 建筑门牌号
        city: '', // 市
        companyName: '', // 雇主/公司名称
        countryCode: '', // 国籍
        countryName: '', // 国籍名称
        derivativeInvestment: '', // 衍生品市场投资年限
        district: '', // 区
        employerBuildingNumber: '', // 雇主建筑门牌号
        employerCity: '', // 雇主市
        employerCountryCode: '', // 雇主国籍
        employerCountryName: '', // 雇主国籍名称
        employerDistrict: '', // 雇主区
        employerProvince: '', // 雇主省
        employerStreet: '', // 雇主街道
        employerZipCode: '', // 雇主邮政编码
        employmentStatus: '', // 就业状态
        employmentName: '', // 就业状态对应的文字
        expectedInvestment: '', // 预期投资水平
        grossAsset: '', // 净资产价值美元
        hasInvestedStockMarket: '', // 是否投资过股市
        industry: '', // 行业
        industryName: '', // 行业对应的名字
        jobTitle: '', // 职位名称
        province: '', // 省
        sourceIncome: '', // 收入来源
        sourceIncomeName: '',
        stockMarketInvestment: '', // 股市投资年限
        street: '', // 街道
        understandBlockchanAssetTrade: '', // 是否了解风险交易区块链资产
        understandDerivativeMarket: '', // 是否了解验证品市场如何运作
        zipCode: '', // 邮政编码
      },
      /* // 性别
      gender: selectOption.genderArr, */
      // 证件类型
      certificateTypes: [],
      loading: false,
      // 是否重新提交，当审核失败后可以重新提交
      isReCommit: false,
      // 工作状态
      workStatus: [],
      // 行业
      industries: [],
      // 资金来源
      sourceIncome: [],
      // 个人资产净价值
      grossAsset: selectOption.grossAssetArr,
      // 预期投资水平
      expectedInvestment: selectOption.expectedInvestmentArr,
      // 是否有股票投资经验
      hasInvestedStockMarket: selectOption.yesOrNoArr,
      // 你了解衍生品市场是如何运作的吗
      understandDerivativeMarket: selectOption.yesOrNoArr,
      // 你知道你正在采取的风险交易快链资产
      understandBlockchanAssetTrade: selectOption.yesOrNoArr,
      loading: false,
      // 弹窗是否显示
      layerModalShow: false,
      // 判断上传插件是否需要初始化，因为用户提交过资料后会立即跳转至详情页，因此这里需要做个判断
      uploaderCanInit: false,
    };
  },
  methods: {
    ...mapActions(['GET_USERINFO_ACTION']),
    // 获取证件类型
    getCertificateTypes() {
      realNameApi.getCertificateTypes()
        .then((res) => {
          let data = res.data;
          let newData = tool.convertArrToOptions(data, 'display', 'value');
          this.certificateTypes = newData;
        });
    },
    // 确定按钮点击事件
    submitBtnClick() {
      this.$v.form.$touch();
      if (this.$v.form.$error) {
        this.$nextTick(() => {
          let timer = setTimeout(() => {
            let firstInvalidEle = document.querySelector('.invalid-class');
            let header = document.getElementById('h_header');
            let headerTop = header ? header.clientHeight : 0;
            let inputEle = firstInvalidEle.querySelector('input');

            tool.scrollToElement(firstInvalidEle, -(headerTop + 30), true);
            (inputEle && inputEle.focus) ? inputEle.focus() : '';

            firstInvalidEle = null;
            header = null;
            inputEle = null;
            clearTimeout(timer);
          }, 500);
        });
        return;
      }
      if (this.loading) {
        return;
      }
      this.form.givenName = this.getRealName;
      let identityType = this.form.identityType;
      let identity = null;
      for (let i = 0, len = this.certificateTypes.length; i < len; i++) {
        if (this.certificateTypes[i].value === identityType) {
          identity = this.certificateTypes[i];
          break;
        }
      }
      this.form.identityName = identity.label;
      this.loading = true;
      let data = {
        ...this.form,
      };

      // 删除一些无效数据
      delete data.year;
      delete data.month;
      delete data.day;
      delete data.lastname;
      delete data.name;
      this._requestRealname(data);
    },
    // 提交实名认证请求
    async _requestRealname(data) {
      realNameApi.certification(data)
        .then((res) => {
          this.loading = false;
          if (res.errcode === 0) {
            // 刷新一遍用户详细数据
            this.GET_USERINFO_ACTION();
            this.$q.notify({
              message: '资料提交成功，等待审核！',
              timeout: 3000, // 以毫秒为单位; 0意味着没有超时
              // 可用的值: 'positive', 'negative', 'warning', 'info'
              type: 'positive',
              color: 'positive',
              position: 'top', // 'top', 'left', 'bottom-left'等
            });
            this.replaceRoute();
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    replaceRoute() {
      this.$router.replace('/usercenter/realname-info');
    },
    // 国籍select事件
    countrySelect(option) {
      this.form.countryName = option.name;
    },
    _uploadSuccess1(file, res) {
      this.form.identifyImgUrl1 = res.uri;
    },
    _uploadSuccess2(file, res) {
      this.form.identifyImgUrl2 = res.uri;
    },
    _uploadSuccess3(file, res) {
      this.form.identifyImgUrl3 = res.uri;
    },
    // 图片类型选择错误回调
    _error(errCode) {
      // Q_TYPE_DENIED: 上传文件类型不正确
      // F_EXCEED_SIZE: 上传的文件体积大于设定的体积
      if (errCode === 'F_EXCEED_SIZE') {
        this.$q.notify({
          color: 'negative',
          message: '上传的图片不能大于5M！',
          icon: 'warning',
          position: 'top',
          type: 'warning',
        });
      } else if (errCode === 'Q_TYPE_DENIED') {
        this.$q.notify({
          color: 'negative',
          message: '只能上传.jpg、.jpeg、.bmp、.png格式的图片',
          icon: 'warning',
          position: 'top',
          type: 'warning',
        });
      }
    },
    // 获取就业状况数据
    getEmploymentStatusData() {
      seniorCertificationApi.getEmploymentStatusData()
        .then((res) => {
          let data = res.data;

          this.workStatus = tool.convertArrToOptions(data, 'display', 'value');
        });
    },
    // 获取行业数据
    getIndustryData() {
      seniorCertificationApi.getIndustryData()
        .then((res) => {
          let data = res.data;

          this.industries = tool.convertArrToOptions(data, 'display', 'value');
        });
    },
    // 获取资金来源数据
    getCapitalSourceData() {
      seniorCertificationApi.getCapitalSourceData()
        .then((res) => {
          let data = res.data;

          this.sourceIncome = tool.convertArrToOptions(data, 'display', 'value');
        });
    },
    // 居住地址select事件
    _countrySelect(option) {
      this.form.countryName = option.name;
    },
    // 雇主国家/地区select事件
    _employerCountrySelect(option) {
      this.form.employerCountryName = option.name;
    },
    // 就业状况select事件
    _employmentStatusSelect(newVal) {
      let option = this.workStatus.filter(item => {
        return item.value === newVal;
      })[0];
      this.form.employmentName = option.label;
    },
    // 行业select事件
    _industrySelect(newVal) {
      let option = this.industries.filter(item => {
        return item.value === newVal;
      })[0];
      this.form.industryName = option.label;
    },
    // 资金来源select事件
    _sourceIncomeSelect(newVal) {
      let option = this.sourceIncome.filter(item => {
        return item.value === newVal;
      })[0];
      this.form.sourceIncomeName = option.label;
    },
    _uploadSuccess1(file, res) {
      this.form.authImgUrl1 = res.uri;
    },
    _uploadSuccess2(file, res) {
      this.form.authImgUrl2 = res.uri;
    },
    // 图片类型选择错误回调
    _error(errCode) {
      // Q_TYPE_DENIED: 上传文件类型不正确
      // F_EXCEED_SIZE: 上传的文件体积大于设定的体积
      if (errCode === 'F_EXCEED_SIZE') {
        this.$q.notify({
          color: 'negative',
          message: '上传的图片不能大于5M！',
          icon: 'warning',
          position: 'top',
          type: 'warning',
        });
      } else if (errCode === 'Q_TYPE_DENIED') {
        this.$q.notify({
          color: 'negative',
          message: '只能上传.jpg、.jpeg、.bmp、.png格式的图片',
          icon: 'warning',
          position: 'top',
          type: 'warning',
        });
      }
    },
  },
  computed: {
    ...mapGetters([getterTypes.Getter_User_Info]),
    ...errMsg,
    // 性别
    gender() {
      return selectOption.genderArr;
    },
    // 计算年份年份
    getYears() {
      let arr = [];
      let year = new Date().getFullYear();
      for (let i = year; i >= 1898; i--) {
        arr.push({ label: i + '', value: i });
      }
      return arr;
    },
    // 获取月份
    getMonth() {
      let arr = [];
      let i = 1;
      for (; i <= 12; i++) {
        arr.push({ label: i + '', value: i });
      }
      return arr;
    },
    // 获取日期
    getDays() {
      let year = this.form.year;
      let month = this.form.month;
      let days = [0, 31, 0, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
      let i = 1;
      let num = 0;
      let results = [];
      if (month === 2) {
        if ((year % 4 === 0 && year % 100 !== 0) || (year % 400 === 0)) {
          num = 29;
        } else {
          num = 28;
        }
      }
      if (month.length === 0) {
        num = 31;
      } else {
        num = days[month];
      }
      for (; i <= num; i++) {
        results.push({ label: i + '', value: i });
      }
      return results;
    },
    // 获取生日日期
    getBirthday() {
      let birthday = this.form.year + '-' + tool.padStartZero(this.form.month) + '-' + tool.padStartZero(this.form.day);
      this.form.birthday = birthday;
      return birthday;
    },
    // 获取姓名拼音
    getRealName() {
      return this.form.lastname.trim().replace(/\b(\w)/gi, function (m, $1) {
        return $1.toUpperCase() + m.substr(1);
      },
      ) + ' ' + this.form.name.trim().replace(/\b(\w)/gi, function (m, $1) {
        return $1.toUpperCase() + m.substr(1);
      },
      );
    },

  },
  components: {
    UploadImg,
    BootstrapModal,
  },
  created() {
    let isEmptyObj = true;
    let isReCommit = this.$route.params.isReCommit;

    // 如果isReCommit为1，则是重新提交
    this.isReCommit = isReCommit * 1 === 1;
    // eslint-disable-next-line
    for (let attr in this.Getter_User_Info) {
      isEmptyObj = false;
      break;
    }

    /* 如果用户在登录后刷新过页面，则在进入此页面时重新获取一次 */
    if (isEmptyObj) {
      this.layerModalShow = true;
      this.GET_USERINFO_ACTION()
        .then(() => {
          let primaryAuthStatus = this.Getter_User_Info.primaryAuthStatus;
          /* if (!this.isReCommit && (primaryAuthStatus === 0 || primaryAuthStatus === 1 || primaryAuthStatus === 2)) {
            this.replaceRoute();
          } else { */
          this.getCertificateTypes();
          this.uploaderCanInit = true;
          // 获取就业状况数据
          this.getEmploymentStatusData();
          // 获取行业数据
          this.getIndustryData();
          // 获取资金来源数据
          this.getCapitalSourceData();
          /* } */
        });
      return;
    }
    // 如果用户已经提交了实名认证资料，并且不是重新提交，则跳转到查看页码
    let primaryAuthStatus = this.Getter_User_Info.primaryAuthStatus;
    /* if (!this.isReCommit && (primaryAuthStatus === 0 || primaryAuthStatus === 1 || primaryAuthStatus === 2)) {
      this.replaceRoute();
    } else { */
    this.getCertificateTypes();
    this.uploaderCanInit = true;
    // 获取就业状况数据
    this.getEmploymentStatusData();
    // 获取行业数据
    this.getIndustryData();
    // 获取资金来源数据
    this.getCapitalSourceData();
    this.layerModalShow = true;
    /* } */
  },
  mounted() {
    this.layerModalShow = true;
    // this.getCertificateTypes();
  },
};
